import { z } from 'zod';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

/** Available subtabs in the settings module */
const SUBTABS = ['funnels', 'custom-fields', 'notifications'] as const;

/** Available sections in the integrations settings page */
/** Scope options for custom field filtering */
const SCOPES = ['all', 'funnel'] as const;

/** Available views in the custom fields interface */
const VIEWS = ['list', 'create', 'edit', 'options'] as const;

/** Custom field entity types */
const ENTITY_TYPES = ['CONTACT', 'FUNNEL_CONVERSATION', 'PRODUCT'] as const;

/**
 * Schema for parsing numeric IDs from query parameters.
 * Converts undefined, null, or empty strings to undefined,
 * and validates positive integers.
 */
const numericId = z
  .preprocess(
    (v) => (v === undefined || v === null || v === '' ? undefined : Number(v)),
    z.number().int().positive()
  )
  .optional();

/**
 * Search schema for the settings page.
 * Extends globalSearchSchema with settings-specific query parameters.
 */
export const settingsSearchSchema = globalSearchSchema.merge(
  z.object({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
    subtab: z.enum(SUBTABS).optional(),
    scope: z.enum(SCOPES).optional(),
    view: z.enum(VIEWS).optional(),
    funnelId: numericId,
    definitionId: numericId,
    entity: z.enum(ENTITY_TYPES).optional(),
  })
);

/** Type derived from settingsSearchSchema for type-safe access to settings search params */
export type SettingsSearch = z.infer<typeof settingsSearchSchema>;
